// Copyright 2005-2010 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_suit_wrap_order=piles.in_suit_wrap_order, in_off_color_wrap_order=piles.in_off_color_wrap_order,
                              up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;

solitaire.canfield = class extends pile_game {
    constructor() {
        super()
        this.pile_game_init(...arguments);
        this.good = new Array(0);
        this.work = new Array(0);
        for (var c=1; c<=4; c++)
            this.good.push(new this.good_pile("good"+c, this));
        for (var c=1; c<=4; c++)
            this.work.push(new this.work_pile("work"+c, this));
        for (var i in this.work)
            this.work[i].game = this;
        this.deck = new pile("deck", this);
        this.play = new pile("play", this);
        this.create_deck(this.deck, this.play, 3);
        this.deck.xoffset /= 2;
        this.deck.yoffset /= 2;
        this.reserve = new this.reserve_pile("reserve", this);
    }

    good_pile = class extends pile_game.generic_foundation {
        constructor(div,game) {
            super(div,game,true)
        }
        accept_stacks = false;
        accept(card) {
                    return this.pile.length == 0 && card.rank == this.start ||
                           this.pile.length      && in_suit_wrap_order(this.top(), card) ? 2 + this.icon_bonus(card) : 0;
        }
    };

    work_pile = class extends pile {
        is_work = true;
        accept_stacks = true;
        accept(card, from_pile) {
                    return (from_pile.is_work && card.length == from_pile.pile.length || // Only drag whole stacks around
                            !from_pile.is_work) &&
                           (this.pile.length == 0 ||
                            this.pile.length      && in_off_color_wrap_order(card[0], this.top())) ? 1 : 0;
        }
        can_drag(index) { return index == 0 || index == this.top_index(); }
        xoffset = 0;
        append_moves(start, n) {
                    return (start == 0 && this.pile.length == n && this.game.reserve.pile.length
                            ? [ { from:this.game.reserve, fstart:this.game.reserve.top_index(), to:this, tstart:0, n:1, internal:true } ]
                            : [] );
        }
        maxstack = Math.ceil(7.92353579175705); // Determined by query in upgrades/maxstack.sql
    };

    reserve_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = 0;
        yoffset = 15/131;
        splice = super.splice_and_turn_over;
    };


    deal(deck) {
            this.deck.pile = deck;
            for (var i=0; i<13; i++) {
                var c;
                this.reserve.push(c = this.deck.pop());
            }
            this.reserve.top().face = up;

            for (var x=0; x<4; x++) {
                var c;
                this.work[x].push(c = this.deck.pop());
                c.face = up;
            }

            var card = this.deck.pop();
            var good = this.good.find(g => g.icon.suit == card.suit);
            good.push(card);
            good.top().face = up;
            for (var i in this.good)
                this.good[i].start = card.rank;
    }

    is_complete() {
            return this.good[0].pile.length == 13 && this.good[1].pile.length == 13 &&
                   this.good[2].pile.length == 13 && this.good[3].pile.length == 13 && WON || NOT_COMPLETE;
    }

    score() {
            return this.count_cards_in(this.good);
    }

    complete() {
            return this.complete_generic(this.good, [this.work, [this.reserve], [this.play]]);
    }

    layout = grid(["deck" ,   {x: +.2}, "play" ,   {x: +.8}, "good1", "good2", "good3", "good4"],
                  [undefined, {x: +.2}, "reserve", {x: +.8}, "work1", "work2", "work3", "work4"]);
}

module.exports = solitaire.canfield;
// Copyright 2005-2010 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_suit_wrap_order=piles.in_suit_wrap_order, in_off_color_wrap_order=piles.in_off_color_wrap_order,
                              up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;

solitaire.canfield = class extends pile_game {
    constructor() {
        super()
        this.pile_game_init(...arguments);
        this.good = new Array(0);
        this.work = new Array(0);
        for (var c=1; c<=4; c++)
            this.good.push(new this.good_pile("good"+c, this));
        for (var c=1; c<=4; c++)
            this.work.push(new this.work_pile("work"+c, this));
        for (var i in this.work)
            this.work[i].game = this;
        this.deck = new pile("deck", this);
        this.play = new pile("play", this);
        this.create_deck(this.deck, this.play, 3);
        this.deck.xoffset /= 2;
        this.deck.yoffset /= 2;
        this.reserve = new this.reserve_pile("reserve", this);
    }

    good_pile = class extends pile_game.generic_foundation {
        constructor(div,game) {
            super(div,game,true)
        }
        accept_stacks = false;
        accept(card) {
                    return this.pile.length == 0 && card.rank == this.start ||
                           this.pile.length      && in_suit_wrap_order(this.top(), card) ? 2 + this.icon_bonus(card) : 0;
        }
    };

    work_pile = class extends pile {
        is_work = true;
        accept_stacks = true;
        accept(card, from_pile) {
                    return (from_pile.is_work && card.length == from_pile.pile.length || // Only drag whole stacks around
                            !from_pile.is_work) &&
                           (this.pile.length == 0 ||
                            this.pile.length      && in_off_color_wrap_order(card[0], this.top())) ? 1 : 0;
        }
        can_drag(index) { return index == 0 || index == this.top_index(); }
        xoffset = 0;
        append_moves(start, n) {
                    return (start == 0 && this.pile.length == n && this.game.reserve.pile.length
                            ? [ { from:this.game.reserve, fstart:this.game.reserve.top_index(), to:this, tstart:0, n:1, internal:true } ]
                            : [] );
        }
        maxstack = Math.ceil(7.92353579175705); // Determined by query in upgrades/maxstack.sql
    };

    reserve_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return index == this.top_index(); }
        xoffset = 0;
        yoffset = 15/131;
        splice = super.splice_and_turn_over;
    };


    deal(deck) {
            this.deck.pile = deck;
            for (var i=0; i<13; i++) {
                var c;
                this.reserve.push(c = this.deck.pop());
            }
            this.reserve.top().face = up;

            for (var x=0; x<4; x++) {
                var c;
                this.work[x].push(c = this.deck.pop());
                c.face = up;
            }

            var card = this.deck.pop();
            var good = this.good.find(g => g.icon.suit == card.suit);
            good.push(card);
            good.top().face = up;
            for (var i in this.good)
                this.good[i].start = card.rank;
    }

    is_complete() {
            return this.good[0].pile.length == 13 && this.good[1].pile.length == 13 &&
                   this.good[2].pile.length == 13 && this.good[3].pile.length == 13 && WON || NOT_COMPLETE;
    }

    score() {
            return this.count_cards_in(this.good);
    }

    complete() {
            return this.complete_generic(this.good, [this.work, [this.reserve], [this.play]]);
    }

    layout = grid(["deck" ,   {x: +.2}, "play" ,   {x: +.8}, "good1", "good2", "good3", "good4"],
                  [undefined, {x: +.2}, "reserve", {x: +.8}, "work1", "work2", "work3", "work4"]);
}

module.exports = solitaire.canfield;
